const IconClose = (props: React.HTMLAttributes<SVGElement>): JSX.Element => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="22"
    viewBox="0 0 30 30"
    fill="none"
  >
    <path
      d="M2.56066 0.625634C1.97487 0.0398478 1.02513 0.0398483 0.43934 0.625634C-0.146446 1.21142 -0.146447 2.16117 0.43934 2.74695L10.6924 13L0.43934 23.253C-0.146447 23.8388 -0.146446 24.7886 0.43934 25.3744C1.02513 25.9602 1.97487 25.9602 2.56066 25.3744L12.8137 15.1213L23.0668 25.3744C23.6525 25.9602 24.6023 25.9602 25.1881 25.3744C25.7739 24.7886 25.7739 23.8388 25.1881 23.2531L14.935 13L25.1881 2.74695C25.7739 2.16117 25.7739 1.21142 25.1881 0.625634C24.6023 0.0398483 23.6525 0.0398483 23.0668 0.625634L12.8137 10.8787L2.56066 0.625634Z"
      fill="currentColor"
    />
  </svg>
);
export default IconClose;
